import React from 'react'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { selectCreatedHomeRoute } from '../../../../store/selectors/home/homeCreate'

const CreateHomeRedirect = props => {
  const route = useSelector(selectCreatedHomeRoute)

  return route ? <Redirect to={route} {...props} /> : null
}

export default CreateHomeRedirect
